<script>
</script>

<main>
  <a href="https://www.synthase.cc/privacy-policy/">Privacy Policy</a>
  &nbsp;&nbsp; | &nbsp;&nbsp;
  <a href="https://www.inside.synthase.cc/terms-of-service/">Terms of Service</a
  >
  &nbsp;&nbsp; | &nbsp;&nbsp;
  <a href="https://www.synthase.cc/web-app-help/">Help</a>
</main>

<style>
  main {
    display: flex;
    align-items: center;
    background-color: #212121;
    width: 100%;
    /* display: block; */
    height: 50px;
    justify-content: center;
  }
  a {
    color: #fff;
  }
</style>
